module.exports = __webpack_public_path__ + "img/测量脚型ico.197b9822.png";